<template src="../../../public/footer_pro.html">  
</template>

<script>
export default ({
  name: 'FooterItem'
})
</script>
